<template>
  <div @click="$emit('card-click', $event)" class="objective-card">
    <p class="objective-card-head">{{ objective.name }}</p>

    <div v-if="canEdit(currentGoal)" class="overlay"></div>
    <div v-else class="overlay"></div>

    <div class="badges">
      <Tooltip v-if="resultPercentage" placement="top" transfer>
        <span class="badge badge-without-icon" :style="{ 'background-color': color }">
          <span :style="{ color: textColor }" class="badge-text">{{ resultPercentage }}</span>
        </span>
        <div slot="content">
          <p>Objective progress score</p>
        </div>
      </Tooltip>

      <Tooltip v-if="nextCheckinDate" placement="top">
        <span class="badge" :class="checkinState">
          <Icon size="16" type="md-time" />
          <span class="badge-text">{{ nextCheckinDate }}</span>
        </span>
        <div slot="content">
          <p>{{ checkinStateTooltip }}</p>
        </div>
      </Tooltip>

      <Tooltip placement="top">
        <span class="badge badge-without-icon">
          <span class="badge-text">{{ objective.priority }} / {{ objectiveQuantity }}</span>
        </span>
        <div slot="content">
          <p>Objective priority ranking</p>
        </div>
      </Tooltip>

      <Tooltip v-if="attachmentQuantity > 0" max-width="400" transfer placement="top">
        <span class="badge">
          <Icon size="16" type="md-attach" />
          <span class="badge-text">{{ attachmentQuantity }}</span>
        </span>
        <div slot="content">
          <p>Attachments for view at check-in</p>
        </div>
      </Tooltip>
    </div>
  </div>
</template>

<script>
import "./objective-card.less";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
let _ = require("lodash");

export default {
  name: "ObjectiveCard",
  props: {
    objective: Object,
    goal: Object,
    objectiveQuantity: Number,
    color: String,
    archivedOrDeleted: Boolean,
  },
  computed: {
    ...mapState("goal", ["currentGoal", "targetUserFilter"]),
    ...mapGetters("goal", ["canEdit"]),
    textColor() {
      let color = this.color ? this.color.toUpperCase() : this.color;
      return !color || color === "#FFFFFF" || color === "#F5F2EE" ? "#515A6E" : "#FFFFFF";
    },
    colorClass() {
      let trackingResult = this.objective.trackingResult;
      trackingResult = NaN;
      if (isNaN(trackingResult)) {
        return {
          "bio-card-default": true,
        };
      } else {
        return {};
      }
    },
    nextCheckin() {
      let context = this;

      if (context.objective && context.objective.checkpoints) {
        let userId = context.targetUserFilter;
        let checkpoints = context.objective.checkpoints.filter((checkpoint) => (userId === 0 ? true : checkpoint.targetUserId === userId) && checkpoint.value !== 0 && !checkpoint.value);
        return _.minBy(checkpoints, (checkpoint) => checkpoint.trackingDate);
      }

      return null;
    },
    nextCheckinDate() {
      let context = this;
      let nextCheckin = context.nextCheckin;

      return nextCheckin ? moment(nextCheckin.trackingDate).format("MMM D") : null;
    },
    nextCheckinDateLong() {
      let context = this;
      let nextCheckin = context.nextCheckin;

      return nextCheckin ? moment(nextCheckin.trackingDate).format("MMM D, YYYY hh:mm a") : null;
    },
    checkinState() {
      let context = this;
      let result = "due-future";

      let nextCheckin = context.nextCheckin;
      if (nextCheckin) {
        let endOfToday = moment().endOf("day");
        if (moment(nextCheckin.trackingDate) < moment()) {
          result = "overdue";
        } else if (moment(nextCheckin.trackingDate) < endOfToday) {
          result = "due-today";
        }
      }

      return result;
    },
    checkinStateTooltip() {
      switch (this.checkinState) {
        case "due-future":
          return "Next check-in due date.";
        case "overdue":
          return "Check-in is overdue!";
        case "due-today":
          return "Check-in is due today!";
        default:
          return "";
      }
    },
    resultPercentage() {
      let context = this;
      if (context.objective && context.objective.trackingResult !== null && !isNaN(context.objective.trackingResult)) {
        var percentage = Math.round(context.objective.trackingResult * 100);
        return `${percentage}%`;
      } else {
        return "";
      }
    },
    attachmentQuantity() {
      if (this.objective && this.objective.attachments) {
        let attachments = JSON.parse(this.objective.attachments);
        return attachments.length;
      }

      return 0;
    },
    attachments() {
      if (this.objective && this.objective.attachments) {
        let attachments = JSON.parse(this.objective.attachments);
        return attachments;
      }

      return null;
    },
  },
  methods: {
    getAttachmentTypeString(type) {
      if (type === 1) {
        return " (video link)";
      } else if (type === 2) {
        return " (document link)";
      } else if (type === 3) {
        return " (web link)";
      } else {
        return "";
      }
    },
    handleMenuItemClick(name) {
      this.$emit(name);
    },
  },
};
</script>
